import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import StatusPage from './StatusPage';
import { createBrowserRouter, RouterProvider } from 'react-router';

import Login from "./Login";
//import { NotFoundPage } from "./pages/NotFoundPage";
import IsAuthorized from "./utils/IsAuthorized";

const router = createBrowserRouter([
    {
        path: "/",
        element: //(
            //<IsAuthorized permissions={["authorized"]}>
                <StatusPage />
            //</IsAuthorized>)
    },
    {
        path: "/signin",
        element: <Login />,
    },
    {
        path: "*",
        element: <h1>404 page not found!!</h1>,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);


